import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './LessonContentRenderer.module.css';

interface TermFlashcardProps {
    label: string;
    definition: string;
}

const TermFlashcard: React.FC<TermFlashcardProps> = ({ label, definition }) => {
    const [isFlipped, setIsFlipped] = useState(false);

    const handleToggle = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsFlipped(!isFlipped);
    };

    return (
        <span
            className={`${styles.termWrapper} ${isFlipped ? styles.termActive : ''}`}
            onClick={handleToggle}
        >
            <span className={styles.termLabel}>{label}</span>
            
            <AnimatePresence>
                {isFlipped && (
                    <div className={styles.flashcardOverlay} onClick={() => setIsFlipped(false)}>
                        <motion.div
                            className={styles.flashcardContainer}
                            initial={{ opacity: 0, rotateY: 90, scale: 0.8, x: '-50%', y: '-50%' }}
                            animate={{ opacity: 1, rotateY: 0, scale: 1, x: '-50%', y: '-50%' }}
                            exit={{ opacity: 0, rotateY: -90, scale: 0.8, x: '-50%', y: '-50%' }}
                            transition={{ duration: 0.4, type: 'spring', damping: 20 }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className={styles.flashcardContent}>
                                <div className={styles.flashcardHeader}>
                                    <span className={styles.flashcardBadge}>Term Definition</span>
                                    <button className={styles.flashcardClose} onClick={() => setIsFlipped(false)}>×</button>
                                </div>
                                <h4 className={styles.flashcardTitle}>{label}</h4>
                                <div 
                                    className={styles.flashcardDefinition}
                                    dangerouslySetInnerHTML={{ __html: definition }}
                                />
                                <div className={styles.flashcardFooter}>
                                    <span>Click anywhere outside to close</span>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </span>
    );
};

export default TermFlashcard;
